import { TDrawScheduleSelect } from "@daymade/api-contracts";
import { DrawScheduleCodeDay, MainDrawDay, MainDrawScheduleCode } from "constants/Draw";

export const getDrawScheduleIds = (drawSchedules:  Record<string, TDrawScheduleSelect>, days: MainDrawDay[]) => {
    return Object.keys(drawSchedules)
      .filter(
        (scheduleId: string) =>
          drawSchedules[scheduleId].code &&
          days.includes(
            DrawScheduleCodeDay[
              drawSchedules[scheduleId].code as MainDrawScheduleCode
            ]
          )
      )
      .map((scheduleId) => drawSchedules[scheduleId].id);
};